import { render, staticRenderFns } from "./TrainerList.vue?vue&type=template&id=72733032"
import script from "./TrainerList.vue?vue&type=script&lang=js"
export * from "./TrainerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports